// extracted by mini-css-extract-plugin
module.exports = {"LogIn":"Register_LogIn__1WI4d","errorMessage":"Register_errorMessage__2AxpS"};